import type { RecentDailyRoutine } from '../dto/DailyRoutineDetails';
import { RoutineError, toRoutineError } from '../errors/RoutineError';
import type { DailyRoutineRepository } from '../ports/DailyRoutineRepository';
import type { DailyStepRepository } from '../ports/DailyStepRepository';
import type { EmotionalProtocolLogRepository } from '../ports/EmotionalProtocolLogRepository';
import type { ProfileId } from '../../domain/shared/ids';
import { failure, success, type Result } from '../../domain/shared/Result';
import { loadRoutineDetails } from './routineDetails';

export class ListRecentDailyRoutines {
  public constructor(
    private readonly dailyRoutines: DailyRoutineRepository,
    private readonly dailySteps: DailyStepRepository,
    private readonly emotionalProtocolLogs: EmotionalProtocolLogRepository,
  ) {}

  public async execute(
    profileId: ProfileId,
    limit = 14,
  ): Promise<Result<readonly RecentDailyRoutine[], RoutineError>> {
    try {
      const routines = (await this.dailyRoutines.listByProfile(profileId))
        .toSorted((first, second) => second.logicalDate.localeCompare(first.logicalDate))
        .slice(0, limit);
      const details = await Promise.all(
        routines.map((routine) =>
          loadRoutineDetails(routine, this.dailySteps, this.emotionalProtocolLogs),
        ),
      );
      return success(details.map(({ routine, progress }) => ({ routine, progress })));
    } catch (error) {
      return failure(toRoutineError(error));
    }
  }
}
